import { Translate, useTranslate } from '@bynder/localization';
import { Props } from './types';
import { useActiveWidget } from '../../../../../queries/guides';
import { CollectionWidget } from '../../../../../types/widgets/collections';
import { SettingsAccordion } from '../../SettingsAccordion';
import { List, Thumbnail } from '@bynder/design-system';
import { IconDownload } from '@bynder/icons';

const CollectionDownloadSettings: React.FC<Props> = ({ handleChange }) => {
  const { translate } = useTranslate();
  const widget = useActiveWidget() as CollectionWidget;
  const { showAssetDownload, showCollectionDownload } =
    widget.collectionSettings;

  return (
    <SettingsAccordion
      thumbnail={<Thumbnail icon={<IconDownload />} />}
      title={translate('WIDGETS_INSPECTOR.COLLECTION_DOWNLOAD_TITLE')}
    >
      <List.Item
        checkedVariant="switch"
        isChecked={showAssetDownload}
        onClick={() => handleChange('showAssetDownload', !showAssetDownload)}
      >
        <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_DOWNLOAD" />
      </List.Item>

      <List.Item
        checkedVariant="switch"
        isChecked={showCollectionDownload}
        onClick={() =>
          handleChange('showCollectionDownload', !showCollectionDownload)
        }
      >
        <Translate id="WIDGETS_INSPECTOR.COLLECTION_COLLECTION_DOWNLOAD" />
      </List.Item>
    </SettingsAccordion>
  );
};

export default CollectionDownloadSettings;
